export default function (event) {
  event = event ? event : window.event;
  const expect = event.target.value.toString() + event.key.toString();
  return !/^\d?\-?\d*[.,]?\d*$/.test(expect) ? event.preventDefault() : false;
}
